export type RiskMatrixBand = 'low' | 'medium' | 'high'

export const riskMatrixLevels = [
  { level: 1, label: 'Low', definition: 'Unlikely or limited in the current context.' },
  { level: 2, label: 'Medium', definition: 'Plausible or material enough to require management attention.' },
  { level: 3, label: 'High', definition: 'Likely, severe or otherwise requiring priority attention.' },
] as const

export function toThreeLevel(value: unknown): number {
  const level = Number(value) || 0
  if (level <= 0) return 0
  if (level <= 3) return Math.max(1, Math.min(3, Math.round(level)))
  return 3
}

export function threeByThreeBand(likelihood: number, consequence: number): RiskMatrixBand {
  const score = likelihood * consequence
  if (score <= 2) return 'low'
  if (score <= 4) return 'medium'
  return 'high'
}

export function riskMatrixLabel(value: unknown): string {
  return riskMatrixLevels.find((item) => item.level === toThreeLevel(value))?.label ?? 'Not rated'
}
